import { motion, useMotionValueEvent, useScroll } from "framer-motion";
import { useState } from "react";
import { PlayButton } from "./PlayButton";
import { EASE } from "@/lib/site";

const LINKS = [
  ["Leaderboard", "#leaderboard"],
  ["Stream", "#stream"],
  ["Socials", "#socials"],
];

export const Nav = () => {
  const { scrollY } = useScroll();
  const [scrolled, setScrolled] = useState(false);
  const [hidden, setHidden] = useState(false);

  useMotionValueEvent(scrollY, "change", (y) => {
    const prev = scrollY.getPrevious() ?? 0;
    setScrolled(y > 40);
    setHidden(y > 300 && y > prev);
  });

  return (
    <motion.header
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: hidden ? -110 : 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: EASE }}
      className={`site-header fixed inset-x-0 top-0 z-50 ${scrolled ? "is-scrolled" : ""}`}
      data-testid="site-nav"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-3 px-4 py-3 sm:px-8 lg:px-12">
        <a href="#top" className="flex items-center gap-3" data-testid="nav-logo-link">
          <img src="/assets/roobet-icon.png" alt="Roobet logo" className="logo-chip h-10 w-10 sm:h-11 sm:w-11" data-testid="nav-roobet-logo" />
          <span className="font-display text-base font-extrabold tracking-tight text-white sm:text-xl" data-testid="nav-brand-text">
            DAFABER <span className="mx-0.5 font-medium text-[#FFC700]">×</span> ROOBET
          </span>
        </a>
        <nav className="nav-links hidden items-center gap-1 rounded-full p-1 md:flex">
          {LINKS.map(([label, href], i) => (
            <a key={href} href={href} className="nav-link" data-testid={`nav-link-${label.toLowerCase()}`}>
              <span className="nav-num">0{i + 1}</span>{label}
            </a>
          ))}
        </nav>
        <PlayButton testId="nav-play-roobet-button" />
      </div>
      <motion.span
        className="header-line"
        initial={{ scaleX: 0 }} animate={{ scaleX: 1 }} transition={{ duration: 1.2, ease: EASE, delay: 0.4 }}
      />
    </motion.header>
  );
};
